import Vue from 'vue';

export default {
  setLocale(state, data) {
    Vue.set(state, 'locale', data);
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js